
'use strict';

//This file is generated using gulp.
//To edit this file, edit the main_js_file.js generator template in the gulp config folder

//import npm plugins

import $ from 'jquery';

//import the manual imports


//import modules

import accordion from '../_1_modules/accordion/accordion';
import demo from '../_1_modules/demo/demo';
import share from '../_1_modules/share/share';
import systemSwitch from '../_1_modules/systemSwitch/systemSwitch';
import codeLineNumbers from '../_1_modules/~on-page-load-JS/codeLineNumbers';
import isIE from '../_1_modules/~on-page-load-JS/isIE';
import isFirefox from '../_1_modules/~on-page-load-JS/isFirefox';
import newWindow from '../_1_modules/~on-page-load-JS/newWindow';

if (!window.Promise) {
	$.getScript('https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.auto.min.js', run_code);
} else {
	run_code();
}

function run_code(){
	$(() => {

		//run manual Imports


		//run modules

		accordion();
		demo();
		share();
		systemSwitch();
		codeLineNumbers();
		isIE();
		isFirefox();
		newWindow();

		$('html').addClass('js-loaded');

	});
}

